import PlanetTransitionScene from '../planetTransitionScene'

export default class VolcanoPlanetTransitionScene extends PlanetTransitionScene {
  constructor() {
    super(
      'VolcanoPlanetTransitionScene',
      'VolcanoPlanetScene',
      'Final Chapter',
      `That was very cold... but alas, still no sign of Froguette. Our protagonist
started feeling sad while remembering the great times he spent with
her back on their home planet, Tadpolurn. But no matter the
challenges he may face, Frogault will never give up!

There is only one other planet besides Tadpolurn: Volcanopiter.
It is the most dangerous planet of this solar system. Let us
hope that she is safe if she was to be there.`
    )
  }
}
